<template>
	<div id="mx-careers-widget" />
</template>

<script setup lang="ts">
const emptyState = defineModel({ type: Boolean,
	default: false })

onMounted(() => {
	const initialEl = document.getElementById('resumator-wrapper')
	if (initialEl) {
		document.body.removeChild(initialEl)
	}
	const script = document.createElement('script')
	script.src = 'https://app.jazz.co/widgets/basic/create/maverixbroadbandinc'
	document.body.appendChild(script)
	script.onload = () => {
		const el = document.getElementById('resumator-wrapper')
		const newParent = document.getElementById('mx-careers-widget')
		if (el && newParent) {
			newParent.appendChild(el)
		}
		nextTick(() => {
			const careerParentDiv = document.getElementById('resumator-jobs')
			if (careerParentDiv && !careerParentDiv?.hasChildNodes()) {
				emptyState.value = true
			}
		})
	}
})

onBeforeUnmount(() => {
	const script = document.querySelector('script[src="https://app.jazz.co/widgets/basic/create/maverixbroadbandinc"]')
	const el = document.getElementById('resumator-wrapper')
	if (script) {
		script.remove()
	}
	if (el) {
		el.remove()
	}
})
</script>
